import { APP_ROUTES } from "@/core/constants";
import type { AppRouteDefinition } from "@/core/router";

import { PlanDetailPage, PlansPage } from "../views";

export const plansRoutes: readonly AppRouteDefinition[] = [
  {
    route: APP_ROUTES.superAdmin.plans,
    element: <PlansPage />,
    children: [
      {
        id: "superAdminPlanDetail",
        route: APP_ROUTES.superAdmin.plans,
        element: <PlanDetailPage />,
        path: `${APP_ROUTES.superAdmin.plans.path}/:planId`,
      },
    ],
  },
] as const;
